module.exports = __webpack_public_path__ + "static/media/send.7476ce8a.png";